import { useCallback, useState } from 'react';
export const useLocalStorage = key => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item;
    } catch (error) {
      console.error(error);
      return null;
    }
  });
  const setValue = useCallback(value => {
    try {
      window.localStorage.setItem(key, value);
      setStoredValue(value);
    } catch (error) {
      console.error(error);
    }
  }, [key]);
  return [storedValue, setValue];
};